/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCreateBranchAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M17 4V0h2v4h4v2h-4v4h-2V6h-4V4zm-.514 8h2.108c-.621 2.138-1.891 3.7-3.377 4.793-1.736 1.278-3.746 1.902-5.322 2.122A4.002 4.002 0 0 1 2 18a4.002 4.002 0 0 1 3-3.874V2h2v12.126A4.008 4.008 0 0 1 9.847 16.9c1.267-.21 2.842-.73 4.185-1.718 1.022-.751 1.92-1.778 2.454-3.182zM4 18a2 2 0 1 0 4 0 2 2 0 0 0-4 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCreateBranchAlt as CreateBranchAlt };
